import { useItem } from "../../../fetch/fetch.item.ts";
import { EMPTY_ITEM } from "../../../const/typeDefault/Item.ts";

const ItemTitle = ({ id }: { id: string }) => {
  const { item, isLoading, isError } = useItem(id, EMPTY_ITEM);
  if (isLoading) return "Titel...";
  if (isError) return isError;
  return item.title;
};
export default ItemTitle;
